import React from 'react';
import PropTypes from 'prop-types';
import { PLACEHOLDER_COLOR } from '../../../styles/variables';

const CubeIcon = ({ color, size }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30">
      <defs>
        <path
          id="CubeIconA"
          d="M18 25.237l8-4.803V7.477l-8 3.2v14.56zm-2 .25V10.754L4 7.326V20.34l12 5.146zM6.863 6.064l10.083 2.88 6.819-2.727-8.735-2.199-8.167 2.046zM2 6a1 1 0 0 1 .757-.97l12.03-3.013a1 1 0 0 1 .488 0l11.97 3.013A1 1 0 0 1 28 6v15a1 1 0 0 1-.485.857l-10 6.005a1 1 0 0 1-.91.061l-14-6.004A1 1 0 0 1 2 21V6z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="CubeIconB" fill="#fff">
          <use xlinkHref="#CubeIconA" />
        </mask>
        <use fill={color || PLACEHOLDER_COLOR} fillRule="nonzero" xlinkHref="#CubeIconA" />
        <g fill={color || PLACEHOLDER_COLOR} mask="url(#CubeIconB)">
          <path d="M0 0h30v30H0z" />
        </g>
      </g>
    </svg>
  );
};

CubeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

CubeIcon.defaultProps = {
  color: PLACEHOLDER_COLOR,
  size: '30px',
};

export default CubeIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Cube/index.js